// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".related-article-list-item__banner[data-v-2da5c2a8]{margin-top:20px;margin-bottom:40px}@media (max-width:767px){.related-article-list-item__banner[data-v-2da5c2a8]{margin-top:0;margin-bottom:20px}}.related-article__category[data-v-2da5c2a8]{margin-top:13px}", ""]);
// Exports
module.exports = exports;
